import { pushToDataLayer } from "../data/data-layer.facade";
import { attachClickEventListener, getBusinessUnit } from "@shared/Utils/analytics-utils";

export type BaseGA4MenuEvent = {
  event: "menu";
  element_category: MenuAnalyticsCategory;
  element_cta?: string;
  business_unit: "B2B" | "B2C";
};

type MenuAnalyticsCategory =
  | "main_menu"
  | "side_menu"
  | "sub_menu"
  | "sub_menu_head"
  | "menu_burger"
  | "footer_menu"
  | "footer_menu_head"
  | "search_bar"
  | "logged_in_dropdown_box";

type GA4MenuTrackingItem = {
  selector: string;
  category: MenuAnalyticsCategory;
  mode?: "data-id" | "query-selector";
  ctaMethod?: "closest" | "try-descendant-first";
};

const GA4_MENU_TRACKING_ITEMS: GA4MenuTrackingItem[] = [
  { selector: "btn-customer-login", category: "logged_in_dropdown_box", mode: "data-id" },
  { selector: "main-menu-logo", category: "side_menu", mode: "data-id" },
  { selector: "Handlekurv", category: "side_menu", mode: "data-id" },
  { selector: "Bedrift", category: "side_menu", mode: "data-id" },
  { selector: "Privat", category: "side_menu", mode: "data-id" },
  { selector: "Menu-Burger-open", category: "side_menu", mode: "data-id" },
  { selector: "footer ul .list li", category: "footer_menu" },
  { selector: "[data-id='search-bar'] button[type='submit']", category: "search_bar" },
  { selector: ".footer__social [data-id]", category: "footer_menu" },
  { selector: "[data-id='main-menu']", category: "main_menu" },
  { selector: "[data-id='footer-menu-head'] a", category: "footer_menu_head" },
  { selector: "[data-id='sub-menu-head']", category: "sub_menu_head", ctaMethod: "try-descendant-first" },
  { selector: "[data-id='sub-menu']", category: "sub_menu" },
];

const sendGA4MenuEvent = (category: MenuAnalyticsCategory, cta: string) => {
  const event: BaseGA4MenuEvent = {
    event: "menu",
    element_category: category,
    element_cta: cta,
    business_unit: getBusinessUnit(),
  };

  pushToDataLayer(event);
};

export const bootstrapMenuAnalytics = (): void => {
  GA4_MENU_TRACKING_ITEMS.forEach(({ selector, category, mode, ctaMethod }) => {
    const items =
      mode === "data-id" ? document.querySelector(`[data-id='${selector}']`) : document.querySelectorAll(selector);

    if (!items) {
      console.warn(`No elements found with selector: ${selector}`);
      return;
    }

    attachClickEventListener(items, (e) => {
      // If clicked outside an href of button, do nothing
      const closestAnchorOrButton = (e.target as HTMLElement).closest<HTMLElement>("a, button");
      if (!closestAnchorOrButton) {
        return;
      }

      let elementToGetCtaFrom: Element | null = null;

      if (ctaMethod === "try-descendant-first") {
        elementToGetCtaFrom = (e.target as HTMLElement).querySelector("[data-id]");
      }

      if (!elementToGetCtaFrom) {
        elementToGetCtaFrom = (e.target as HTMLElement).closest<HTMLElement>("[data-id]");
      }

      const cta = elementToGetCtaFrom?.getAttribute("data-id") || "unknown";
      sendGA4MenuEvent(category, cta);
    });
  });
};
